export default [
    'originacoesListRequestStatus',
    'selecaoManualRequestStatus',
    'originacaoRequestStatus',
    'confirmOriginacaoRequestStatus',
    'exportOriginacaoRequestStatus',
];
